import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BillList } from "@/components/expenses/bill-list";
import { SchedulesTab } from "@/components/expenses/schedules-tab";
import { PrepaidTab } from "@/components/expenses/prepaid-tab";

// Phase 57 Plan 16 — replaces the legacy Dues&Payments/Recurring two-tab
// page (550 lines, single file) with the Bills/Schedules/Prepaid surface a
// real GL-backed expense subsystem needs. 57-CONTEXT.md's "replace, do not
// extend" is locked: this is the ONLY page routed at /expenses now — the
// legacy `expense_templates`/`expense_entries` tables and
// `routes/expenses.ts` stay untouched on disk (a later, operator-gated
// migration drops them), but nothing in the CRM links to them any more.
export default function Expenses() {
  // Bumped by the Schedules tab's "Generate bills" toast action when
  // `incomplete > 0`, so the Bills tab can jump straight to the rows that
  // need an expense-account mapping before they can be submitted.
  const [zeroTotalDraftsSignal, setZeroTotalDraftsSignal] = useState<number | undefined>(undefined);
  const [tab, setTab] = useState("bills");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Expenses</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Vendor bills, recurring schedules and prepaid recognition — every bill posts to the general ledger.
        </p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="grid grid-cols-3 w-full max-w-lg">
          <TabsTrigger value="bills">Bills</TabsTrigger>
          <TabsTrigger value="schedules">Schedules</TabsTrigger>
          <TabsTrigger value="prepaid">Prepaid</TabsTrigger>
        </TabsList>
        <TabsContent value="bills">
          <BillList zeroTotalDraftsSignal={zeroTotalDraftsSignal} />
        </TabsContent>
        <TabsContent value="schedules">
          <SchedulesTab
            onIncompleteGenerated={() => {
              setZeroTotalDraftsSignal((n) => (n ?? 0) + 1);
              setTab("bills");
            }}
          />
        </TabsContent>
        <TabsContent value="prepaid">
          <PrepaidTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
